import { useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { bindActionCreators } from "redux";
import {
  trunkGetStorageList,
  trunkGetStorageStoppedList,
  trunkGetStorageDetail,
  trunkCheckStorageStatus,
  trunkUpdateStorageStatus,
  trunkDeleteStorage,
} from "../store/admin/adminStorage";

const useAdminStorageStore = () => {
  const adminStorageStore = useRootState(
    (state) => state.adminStorageStore
  );

  const dispatch = useAppDispatch();

  const boundGetStorageList = useMemo(
    () => bindActionCreators(trunkGetStorageList, dispatch),
    [dispatch]
  );
  const boundGetStorageStoppedList = useMemo(
    () => bindActionCreators(trunkGetStorageStoppedList, dispatch),
    [dispatch]
  );
  const boundGetStorageDetail = useMemo(
    () => bindActionCreators(trunkGetStorageDetail, dispatch),
    [dispatch]
  );
  const boundCheckStorageStatus = useMemo(
    () => bindActionCreators(trunkCheckStorageStatus, dispatch),
    [dispatch]
  );
  const boundUpdateStorageStatus = useMemo(
    () => bindActionCreators(trunkUpdateStorageStatus, dispatch),
    [dispatch]
  );
  const boundDeleteStorage = useMemo(
    () => bindActionCreators(trunkDeleteStorage, dispatch),
    [dispatch]
  );

  return {
    adminStorageStore,
    boundGetStorageList,
    boundGetStorageStoppedList,
    boundGetStorageDetail,
    boundCheckStorageStatus,
    boundUpdateStorageStatus,
    boundDeleteStorage,
  };
};

export default useAdminStorageStore;
